
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/material-ui/guides/building-extensible-themes",
      function () {
        return require("private-next-pages/material-ui/guides/building-extensible-themes.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/material-ui/guides/building-extensible-themes"])
      });
    }
  